import { TITLES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(TITLES_ENDPOINT);
export default instance;
